import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ApplicationLinkManifest } from './CommonApplicationLinkCreationEntity.tsx';

// ManifestResource
export const fetchThisManifest = (): Promise<ApplicationLinkManifest> =>
	fetchJson('/rest/applinks/3.0/manifest.json');
